// Generated by AvenyModelEditor 2020-11-30 08:14

export const Roles: {[key: string]: string} = {
  '3001': 'Expedition, Aveny Bisättning',
  '3002': 'Begravningsbyrå, Aveny Bisättning Web',
  '3003': 'Administratör, Aveny Bokning',
  '3004': 'Bokningsbeställningar, Aveny Bokning',
  '3005': 'Expedition, Aveny Bokning',
  '3006': 'Läsbehörig, Aveny Bokning',
  '3007': 'Publicering, Aveny Bokning',
  '3008': 'Begravningsbyrå, Aveny Bokning WEB',
  '3009': 'Bokare, Aveny Bokning WEB',
  '3010': 'Läsbehörighet, Aveny Bokning WEB',
  '3011': 'Publicering, Aveny Bokning WEB',
  '3012': 'Expedition, Aveny Diarium',
  '3013': 'Läsbehörig, Aveny Diarium',
  '3014': 'Administratör, Aveny Grav',
  '3015': 'Arbetsledare, Aveny Grav',
  '3016': 'Expedition, Aveny Grav',
  '3017': 'Kyrkogårdsarbetare, Aveny Grav',
  '3018': 'Läsbehörighet, Aveny Grav',
  '3019': 'Administratör, Aveny Kremation',
  '3020': 'Läsbehörig, Aveny Kremation',
  '3021': 'Musiker, Aveny Musik',
  '3022': 'Aveny Systemansvarig',
  '3023': 'Administratör, Aveny Bisättning',
  '3024': 'Administratör, Aveny Diarium',
  '3025': 'Administratör, Aveny Tidredovisning',
  '3026': 'Administratör, Aveny myCarta',
  '3027': 'Läsbehörig, Aveny myCarta',
  '3028': 'Publicera kartor, Aveny myCarta',
  '3029': 'Handläggare, Aveny Tvist,',
  '3030': 'Läsbehörig, Aveny Bisättning',
  '3031': 'Läsbehörighet, Aveny Diarium WEB',
  '3032': 'WEB Statistik, Aveny Bokning',
  '3033': 'WEB Boka Gudstjänst, Aveny Bokning',
  '3034': 'Församling, Aveny Bokning WEB',
  '3035': 'Församling, Aveny Bisättning WEB',
  '7010': 'Nationellt, Systemadministratör',
  '7110': 'GAS Support',
  '7120': 'Ekonom',
  '7121': 'Ekonomiassistent',
  '7122': 'Revision',
  '7123': 'Kyrkoherde',
  '7124': 'Ordförande',
  '7125': 'Ekonomi/inköpare, Standardanvändare',
  '7126': 'Verksamhetsansvarig',
  '7127': 'Verksamhetschef',
  '7128': 'Verksamhetschef SB',
  '7129': 'WebAveny, Administratör',
  '7130': 'Gas, Lönehandläggare',
  '7131': 'Controller',
  '7132': 'Kundorder, Administratör',
  '7134': 'Betalningar, Kollekt och',
};
